import { useContext } from 'react';
import { Elements } from '@stripe/react-stripe-js';
import CheckoutModal from './checkout-modal';
import PaymentSuccess from '../../../../ui-components/payment-success';
import { StripeElementsOptions } from '@stripe/stripe-js';
import LoadingPaymentModal from '../../../../ui-components/loading-payment-modal';
import useLocale from '../../../../Hooks/use-locale';
import useTypeSafeLocalize from '../../../../Hooks/use-type-safe-localize';
import {
  LocalizationCategory,
  ProductLocalization,
} from '../../../../localizations/types';
import useBookingPrices from '../../../../Hooks/use-booking-prices';
import useStripeAppearance from '../../../../Hooks/use-stripe-appearance';
import { bookingState } from '../../client-state/booking-state-context';
import { isSummaryOpenActionTypes } from '../../../../redusers/is-summary-open-reducer';
import { paymentReducerActionTypes } from '../../../../redusers/payment-reducer';
import useBookingShop from '../../server-data/use-booking-shop';
import useStripeObject from '../../../../Hooks/use-stripe-object';

const BookingPaymentModalWrapper = () => {
  const stripe = useStripeObject();
  console.log('BookingPaymentModalWrapper stripe', stripe);
  const { data: shop } = useBookingShop();
  const { state, dispatch } = useContext(bookingState);
  const { language, languageAsEnum } = useLocale();
  const localize = useTypeSafeLocalize();
  const { bookingPrices } = useBookingPrices();
  const stripeAppearance = useStripeAppearance();

  const stripeOptions: StripeElementsOptions = {
    appearance: stripeAppearance,
  };

  if (state.payment.paymentIntentClientSecret) {
    stripeOptions.clientSecret = state.payment.paymentIntentClientSecret;
  }

  // if balance is below 0, a payment should be made, so we should wait for a payment intent
  // to be created
  if (
    bookingPrices.balance &&
    bookingPrices.balance < 0 &&
    !state.payment.paymentIntentClientSecret
  ) {
    return (
      <LoadingPaymentModal
        customer={state.customer.customer}
        toBePaid={bookingPrices.toBePaid}
        onClose={() => {
          dispatch({
            type: isSummaryOpenActionTypes.SET_IS_OPEN,
            payload: false,
          });
          dispatch({
            type: paymentReducerActionTypes.UPDATE_SHOW_PAYMENT_MODAL,
            payload: false,
          });
        }}
      />
    );
  }

  if (state.payment.isPaid) {
    return (
      <PaymentSuccess
        heading={
          shop?.bookingLocalizations?.paymentSuccessHeading?.[languageAsEnum] ||
          `${localize(
            LocalizationCategory.product,
            ProductLocalization.thankYou
          )} ${localize(LocalizationCategory.product, ProductLocalization.captain)}`
        }
        text={
          shop?.bookingLocalizations?.paymentSuccessText?.[languageAsEnum] ||
          localize(
            LocalizationCategory.product,
            ProductLocalization.defaultPaymentSuccessText
          )
        }
        link={
          shop?.bookingLocalizations?.paymentSuccessLink?.[languageAsEnum] ||
          shop?.website
            ? `https://${shop?.website}`
            : language === 'en'
            ? 'https://goboat.dk/en'
            : 'https://goboat.dk'
        }
        showEmail={true}
        customer={state.customer.customer}
      />
    );
  }

  return (
    <Elements stripe={stripe ?? null} options={stripeOptions}>
      <CheckoutModal />
    </Elements>
  );
};

export default BookingPaymentModalWrapper;
